import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { GridRow } from 'dibs-elements/exports/Grid';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

import { HpRespModuleContainer } from '../HpRespModuleContainer/HpRespModuleContainer';
import HpRespShopByModuleItem from './HpRespShopByModuleItem';
import { trackShopByItemsImpressions, trackShopByItemClick } from '../helpers/shopByTracking';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

export const handleInitialDisplay = ({ inViewport, items }) => {
    if (items && inViewport) {
        trackShopByItemsImpressions(items);
    }
};

export const HpRespShopByModuleComponent = ({ componentModule, useLazyLoadImages }) => {
    if (!componentModule) {
        return null;
    }

    const { items = [], title } = componentModule;

    return (
        <HpRespModuleContainer addTopGap>
            <PageLayout setViewportBackground="sassyColorMoonstone">
                <HpRespModuleContainer.Header title={title} />
                <SharedInViewport
                    stopWhenInViewport
                    onInViewportChange={({ inViewport }) =>
                        handleInitialDisplay({ inViewport, items })
                    }
                >
                    <GridRow>
                        {items.map((item, index) => {
                            return (
                                <HpRespShopByModuleItem
                                    key={item.cmsId}
                                    item={item}
                                    onClick={() => trackShopByItemClick(item, index)}
                                    useLazyLoadImages={useLazyLoadImages}
                                />
                            );
                        })}
                    </GridRow>
                </SharedInViewport>
            </PageLayout>
        </HpRespModuleContainer>
    );
};

HpRespShopByModuleComponent.propTypes = {
    componentModule: PropTypes.object.isRequired,
    useLazyLoadImages: PropTypes.bool,
};

export const HpRespShopByModule = createFragmentContainer(HpRespShopByModuleComponent, {
    componentModule: graphql`
        fragment HpRespShopByModule_componentModule on ShopByModule {
            title
            items {
                cmsId
                linkData {
                    # shopByTracking.js
                    path
                }
                ...HpRespShopByModuleItem_item
            }
        }
    `,
});
